import { FC, Fragment } from 'react';
import { Route, Switch } from 'react-router-dom';
import RouteConstants from '../router/RouteConstants';
import { ComuniContainer } from './ComuniContainer';

/** Nested routes use plain Route: Layout.routes already wraps ComuniRouter in PrivateRoute.
 * Re-wrapping with PrivateRoute remounts on every render and resets inbox list state. */
export const ComuniRouter: FC = () => (
  <Fragment>
    <Switch>
      <Route path={RouteConstants.comuni} component={ComuniContainer} />
    </Switch>
  </Fragment>
);
